import { createContext, useContext } from "react";
const OfferActionContext = createContext(null);
export function useOfferActionContext() {
    const ctx = useContext(OfferActionContext);
    if (!ctx) {
        return {};
    }
    return ctx;
}
export { OfferActionContext };
